var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _rect5, _rect6, _rect7, _rect8, _path5, _rect9, _rect0, _rect1, _rect10, _path6, _rect11, _rect12, _rect13, _rect14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleItemMultiplePricesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 124,
    viewBox: "0 0 164 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 162,
    height: 122,
    rx: 5,
    fill: "#F0F9F5",
    stroke: "#68C598",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 89,
    width: 40,
    height: 3,
    rx: 1.5,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 96,
    width: 40,
    height: 3,
    rx: 1.5,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 76,
    width: 40,
    height: 5,
    rx: 2.5,
    fill: "#BBBBBB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67 20H22V65H67V20ZM65.0583 22.0245H24.0264V63.087H65.0583V22.0245Z",
    fill: "#68C598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.063 51.2781L39.1472 37.9043L26.29 57.19H43.9247L43.8569 57.2868H61.8569L52.8569 44.4296L48.063 51.2781Z",
    fill: "#68C598"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.488 40.5848C58.3614 40.5848 60.6908 38.2791 60.6908 35.435C60.6908 32.5908 58.3614 30.2852 55.488 30.2852C52.6145 30.2852 50.2852 32.5908 50.2852 35.435C50.2852 38.2791 52.6145 40.5848 55.488 40.5848Z",
    fill: "#68C598"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.171 17.7129H86.2469C84.6875 17.7129 83.4233 19.056 83.4233 20.7129V38.7129C83.4233 40.3697 84.6875 41.7129 86.2469 41.7129H149.171C150.731 41.7129 151.995 40.3697 151.995 38.7129V20.7129C151.995 19.056 150.731 17.7129 149.171 17.7129Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 124.572,
    y: 26.8555,
    width: 20,
    height: 7,
    rx: 3.5,
    fill: "#68C598"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 91.4287,
    y: 24,
    width: 22,
    height: 3,
    rx: 1.5,
    fill: "#BBBBBB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 30.4316,
    width: 22,
    height: 1.5,
    rx: 0.75,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 34,
    width: 18,
    height: 1.5,
    rx: 0.75,
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.171 49.7129H86.2469C84.6875 49.7129 83.4233 51.056 83.4233 52.7129V70.7129C83.4233 72.3697 84.6875 73.7129 86.2469 73.7129H149.171C150.731 73.7129 151.995 72.3697 151.995 70.7129V52.7129C151.995 51.056 150.731 49.7129 149.171 49.7129Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 124.572,
    y: 58.8555,
    width: 20,
    height: 7,
    rx: 3.5,
    fill: "#68C598"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 91.4287,
    y: 56,
    width: 22,
    height: 3,
    rx: 1.5,
    fill: "#BBBBBB"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 62.4316,
    width: 22,
    height: 1.5,
    rx: 0.75,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 66,
    width: 18,
    height: 1.5,
    rx: 0.75,
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149.171 81.7129H86.2469C84.6875 81.7129 83.4233 83.056 83.4233 84.7129V102.713C83.4233 104.37 84.6875 105.713 86.2469 105.713H149.171C150.731 105.713 151.995 104.37 151.995 102.713V84.7129C151.995 83.056 150.731 81.7129 149.171 81.7129Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 124.572,
    y: 90.8555,
    width: 20,
    height: 7,
    rx: 3.5,
    fill: "#68C598"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 91.4287,
    y: 88,
    width: 22,
    height: 3,
    rx: 1.5,
    fill: "#BBBBBB"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 94.4316,
    width: 22,
    height: 1.5,
    rx: 0.75,
    fill: "#D9D9D9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 98,
    width: 18,
    height: 1.5,
    rx: 0.75,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleItemMultiplePricesActive);
export default __webpack_public_path__ + "static/media/single-item-multiple-prices-active.59891303f9ecf43feb20f671e3a302f2.svg";
export { ForwardRef as ReactComponent };